/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/hash': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<circle pid="0" cx="9" cy="9" r="8.5" _fill="#DE4E44" _stroke="#F8F8F8"/><path pid="1" d="M6.827 11.04h-.73V9.858h.966l.323-1.584h-1.29V7.087h1.531l.425-2.095h1.203L8.83 7.087h1.187l.413-2.095h1.246l-.43 2.095h.742v1.187h-.983l-.322 1.584h1.305v1.182h-1.547l-.424 2.095H8.82l.413-2.095H8.041l-.424 2.095H6.403l.424-2.095zm1.767-2.766l-.317 1.584H9.47l.311-1.584H8.594z" _fill="#F8F8F8"/>'
  }
})
